// @ts-check
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Accordion from '../../custom/Accordion';
import AccordionSummary from '../../custom/AccordionSummary';
import AccordionDetails from '../../custom/AccordionDetails';
import SimpleTextInput from '../common/SimpleTextInput'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import useFormStyles from '../../common/FormStyle';
import { heatingSystems, coolingSystems } from '../common/constants';

import {
  SET_SUSTAINABILITY_FIELD,
  SET_HEATING_SYSTEMS,
  SET_COOLING_SYSTEMS
} from '../../../redux/actions/actionTypes'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 420,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const heatingSystemsOptionsNameToVal = {
  'Gas boiler': 'GAS_BOILER',
  'Electric boiler': 'ELECTRIC_BOILER',
  'Radiators': 'RADIATORS',
  'Under floor heating': 'UNDER_FLOOR_HEATING',
  'Electric (Air conditioning (HVAC/Heat pump)': 'ELECRIC',
}

const heatingSystemsOptionsValToName = {
  'GAS_BOILER': 'Gas boiler',
  'ELECTRIC_BOILER': 'Electric boiler',
  'RADIATORS': 'Radiators',
  'UNDER_FLOOR_HEATING': 'Under floor heating',
  'ELECRIC': 'Electric (Air conditioning (HVAC/Heat pump)'
}

function EnergyEfficiency(props) {
  const formStyles = useFormStyles();
  const classes = useStyles();
  const sustainabilityState = useSelector(state => state.globalFormData.sustainability);
  const heatingSystemsVal = sustainabilityState.heating_systems
  const coolingSystemsVal = sustainabilityState.cooling_systems

  const dispatch = useDispatch()

  const [expanded, setExpanded] = useState(false);
  const handleExpanded = () => {
    setExpanded(!expanded);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <>
      <Accordion expanded={expanded} onChange={handleExpanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon fontSize="small" />}
          aria-controls="Sustainability-content"
          id="Sustainability-header"
          IconButtonProps={{
            className: formStyles.expandButton
          }}
        >
          <Typography className={clsx(formStyles.accordionSubheader, formStyles.bold)}>Energy efficiency</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Box className={clsx(formStyles.w100)}>

            <FormControl className={classes.formControl}>
              <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)} color="textSecondary">
                Heating system energy source
              </Typography>
              <Select
                // labelId="demo-simple-select-label"
                // id="demo-simple-select"
                value={heatingSystemsVal}
                onChange={(event) => {
                  // @ts-ignore
                  const val = event.target.value
                  dispatch({
                    type: SET_HEATING_SYSTEMS,
                    payload: val
                  })
                }}
              >
                <MenuItem value={'NO_HEATING'}>{heatingSystems.NO_HEATING}</MenuItem>
                <MenuItem value={'GAS_BOILER_RADIATORS'}>{heatingSystems.GAS_BOILER_RADIATORS}</MenuItem>
                <MenuItem value={'GAS_BOILER_UNDER_FLOOR'}>{heatingSystems.GAS_BOILER_UNDER_FLOOR}</MenuItem>
                <MenuItem value={'ELECTRIC_BOILER_RADIATORS'}>{heatingSystems.ELECTRIC_BOILER_RADIATORS}</MenuItem>
                <MenuItem value={'ELECTRIC_BOILER_UNDER_FLOOR'}>{heatingSystems.ELECTRIC_BOILER_UNDER_FLOOR}</MenuItem>
                <MenuItem value={'ELECTRIC_HVAC'}>{heatingSystems.ELECTRIC_HVAC}</MenuItem>
              </Select>
            </FormControl>

            <FormControl className={classes.formControl}>
              <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)} color="textSecondary">
                Cooling system energy source
              </Typography>
              <Select
                // labelId="demo-simple-select-label"
                // id="demo-simple-select"
                value={coolingSystemsVal}
                onChange={(event) => {
                  // @ts-ignore
                  const val = event.target.value
                  dispatch({
                    type: SET_COOLING_SYSTEMS,
                    payload: val
                  })
                }}
              >
                <MenuItem value={'NO_COOLING'}>{coolingSystems.NO_COOLING}</MenuItem>
                <MenuItem value={'AIR_CONDITIONING'}>{coolingSystems.AIR_CONDITIONING}</MenuItem>

              </Select>
            </FormControl>

            <Divider className={formStyles.divider} />

            <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)} color="textSecondary">
              Carbon factors - emission rates (CO₂/kWh)
            </Typography>

            <Box>
              <SimpleTextInput label="Heating" name="heating" type="number"
                value={sustainabilityState.heating}
                onChange={(event) => {
                  dispatch({
                    type: SET_SUSTAINABILITY_FIELD,
                    payload: {
                      field: 'heating',
                      value: event.target.value
                    }
                  })
                }}
              />

              <SimpleTextInput label="Cooling" name="heating" type="number"
                value={sustainabilityState.cooling}
                onChange={(event) => {
                  dispatch({
                    type: SET_SUSTAINABILITY_FIELD,
                    payload: {
                      field: 'cooling',
                      value: event.target.value
                    }
                  })
                }}
              />

              <SimpleTextInput label="Lighting" name="heating" type="number"
                value={sustainabilityState.lighting}
                onChange={(event) => {
                  dispatch({
                    type: SET_SUSTAINABILITY_FIELD,
                    payload: {
                      field: 'lighting',
                      value: event.target.value
                    }
                  })
                }}
              />

            </Box>

          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default EnergyEfficiency